// http://goo.gl/XkBrjD
var $export = require('./$.export')
  , $values = require('./$.object-to-array')(false);

$export($export.S, 'Object', {
  values: function values(it){
    return $values(it);
  }
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-polyfill/~/core-js/modules/es7.object.values.js
 ** module id = 366
 ** module chunks = 0
 **/